import React from 'react';
import { Dialog, FlatButton, RaisedButton } from 'material-ui';
import { connect } from 'react-redux';


const GlobalAlertBox = props => {
  const { text, onClose, onOk, open } = props;
  const onClickOk = () => {
    onClose();
    if (onOk) onOk();
  };
  return (
    <Dialog
      style={{ zIndex: 1501 }}
      open={open}
      actions={[
        Boolean(onOk) && <FlatButton
          key="cancel"
          onClick={onClose}
          label="Cancel"
          secondary
        />,
        <RaisedButton
          key="ok"
          onClick={onClickOk}
          label="OK"
          secondary
        />,
      ]}
    >
      <div style={{ whiteSpace: 'pre-wrap' }}>
        {text}
      </div>
    </Dialog>
  );
};

const mapState = ({ globalAlert }) => globalAlert;

const mapActions = ({
  onClose: () => ({ type: 'close_global_alert' }),
});
export default connect(mapState, mapActions)(GlobalAlertBox);



// WEBPACK FOOTER //
// ./src/app/components/containers/global-alert-box.jsx